import { PrimaryInfo } from './../util';
import { ARSProvider } from '../../models/ARSProvider';

export const getSuggestion = (ars: ARSProvider): PrimaryInfo => {
    return {
        name: ars.name,
        id: ars.id
    };
};
